<template>
  <div class="fair-survey-step">
    <div class="fair-survey-step__head">
      <h2 class="fair-survey-step__title">
        {{ step.title }}
      </h2>
      <p
        v-if="step.subtitle"
        class="fair-survey-step__subtitle"
      >
        {{ step.subtitle }}
      </p>
    </div>

    <div class="gift-step__fields">
      <div class="gift-step__field">
        <span class="gift-step__label">Имя</span>
        <FairInputText
          v-model="recipientName"
          placeholder="Введите имя"
          @update:model-value="updateName"
        />
      </div>

      <div class="gift-step__field">
        <span class="gift-step__label">Кем приходится</span>
        <FairDropdown
          v-model="selectedRelationship"
          :options="step.relationshipOptions.map((option) => ({
            key: option.value,
            label: option.label,
          }))"
          placeholder="Выберите"
          show-radio
          @update:model-value="updateRelationship"
        />
      </div>

      <div class="gift-step__field">
        <span class="gift-step__label">Пол</span>
        <FairDropdown
          v-model="selectedGender"
          :options="genderOptions.map((option) => ({
            key: option.value,
            label: option.label,
          }))"
          placeholder="Выберите"
          show-radio
          @update:model-value="updateGender"
        />
      </div>

      <div class="gift-step__field">
        <span class="gift-step__label">Возраст</span>
        <FairDropdown
          v-model="selectedAge"
          :options="step.ageOptions.map((option) => ({
            key: option.value,
            label: option.label,
          }))"
          placeholder="Выберите"
          show-radio
          @update:model-value="updateAge"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { FairDropdown } from '@/ui/primitives/FairDropdown'
import { FairInputText } from '@/ui/primitives/FairInputText'
import { useGiftModal } from '@/features/gift/store'
import type { GiftStep, GenderValue } from '@/features/gift/types/gift-config'

interface Props {
  step: GiftStep & { type: 'recipient_info' }
}

const props = defineProps<Props>()
const giftStore = useGiftModal()

const recipientName = ref<string>('')
const selectedRelationship = ref<string | null>(null)
const selectedGender = ref<GenderValue | null>(null)
const selectedAge = ref<string | null>(null)

const genderOptions = [
  { value: 'male', label: 'Мужской' },
  { value: 'female', label: 'Женский' }
]

function updateName() {
  giftStore.updateGiftData(`${props.step.id}_name`, recipientName.value)
}

function updateRelationship() {
  giftStore.updateGiftData(`${props.step.id}_relationship`, selectedRelationship.value)
}

function updateGender() {
  giftStore.updateGiftData(`${props.step.id}_gender`, selectedGender.value)
}

function updateAge() {
  giftStore.updateGiftData(`${props.step.id}_age`, selectedAge.value)
}

onMounted(() => {
  const data = giftStore.giftModal.giftData
  recipientName.value = data[`${props.step.id}_name`] || ''
  selectedRelationship.value = data[`${props.step.id}_relationship`] || null
  selectedGender.value = data[`${props.step.id}_gender`] || null
  selectedAge.value = data[`${props.step.id}_age`] || null
})
</script>

<style scoped>
.gift-step__fields {
  display: flex;
  flex-direction: column;
  gap: var(--fair-rd-space-24);
}

.gift-step__field {
  display: flex;
  flex-direction: column;
  gap: var(--fair-rd-space-8);
}

.gift-step__label {
  font-family: var(--fair-rd-font-display, 'Gilroy', sans-serif);
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--fair-rd-text-muted);
}

/* Sub-question belongs to the option above it, so it is indented under it. */
.gift-step__sub {
  padding: var(--fair-rd-space-8) 0 var(--fair-rd-space-8)
    var(--fair-rd-space-40);
}
</style>
